


























































import { Component, Prop, Watch, Model, Ref } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'
import PinchZoom from 'vue-pinch-zoom'

@Component({
  components: { PinchZoom },
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  @Model('input', { default: null }) readonly value: any
  @Prop({ default: '1' }) readonly ratio: string | number
  @Prop({ default: undefined }) readonly width: string | undefined
  @Prop({ default: undefined }) readonly height: string | undefined
  @Prop({ default: false }) readonly outlined: boolean
  @Prop({ default: false }) readonly round: boolean
  @Ref() fileInput
  @Ref() imageWrap: HTMLDivElement

  uploadFile: any = null
  showImagePop: boolean = false
  imgLoaded: boolean = false
  preViewImage: string | undefined = null
  asIsImage: string | undefined = null
  calculatedRatio: string | number = null
  size = {
    width: null,
    height: null,
  }

  sizeStyle: string = ''

  get imagesRatio() {
    return (100 / Number(this.calculatedRatio)).toFixed(4)
  }

  created() {
    console.log('created - ', this.value)
    this.asIsImage = this.value
    this.preViewImage = this.asIsImage
  }

  mounted() {
    this.sizeInit()
  }

  sizeInit() {
    this.calculatedRatio = this.ratio
    this.size = {
      width: this.width ? this.calcSize(this.width) : undefined,
      height: this.height ? this.calcSize(this.height) : undefined,
    }
    if (this.size.width && this.size.height) {
      this.calculatedRatio = this.calcRatio()
    }
    // console.log('calc - ', this.calculatedRatio, this.imagesRatio)
  }

  calcRatio() {
    const width = this.imageWrap.clientWidth
    const height = this.imageWrap.clientHeight

    return (height / width).toFixed(4)
  }

  calcSize(size) {
    if (typeof size === 'string') {
      if (size.charAt(size.length - 1) !== '%') {
        size = size + 'px'
      }
    }
    return size
  }

  onClickChooseImg() {
    // console.log('choose img click!!')
    this.fileInput.$refs.input.click()
  }

  onClickModify() {
    this.fileInput.$refs.input.click()
  }

  onClickZoom() {
    if (this.imgLoaded && this.preViewImage) {
      this.showImagePop = true
    } else {
      alert('이미지가 로드 되지 않았습니다.')
    }
  }

  async onClickRemove() {
    if (await confirm('삭제하시겠습니까?')) {
      if (this.uploadFile === null) this.onUploadFileChanged(null)
      this.uploadFile = null
      this.preViewImage = null
    }
  }

  onChangeFileInput(file: any) {
    // console.log('on change file - ', this.uploadFile, typeof file)
    this.preViewImage = URL.createObjectURL(this.uploadFile)
  }

  @Watch('value', { deep: true })
  onValueChanged(val) {
    console.log('Watch - ', this.value)
    this.uploadFile = val
  }

  @Watch('uploadFile')
  onUploadFileChanged(val) {
    // console.log('watch file changed!! ', val)
    this.$emit('input', val)
  }
}
